import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { QrCode, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { PHONES } from "@/lib/landingData";

const ORDER = ["a", "c", "b"];

const MockScreen = () => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % ORDER.length), 3200);
    return () => clearInterval(t);
  }, []);
  const data = PHONES[ORDER[idx]];
  return (
    <AnimatePresence mode="wait">
      <motion.div key={ORDER[idx]} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -14 }} transition={{ duration: 0.45 }}>
        <div className="h-28 bg-gradient-to-br from-[#5aa469] to-[#3f7a4b] relative">
          <p className="absolute bottom-4 left-5 text-white font-display font-bold text-xl leading-none">{data.title}</p>
        </div>
        <div className="p-5 space-y-4">
          <p className="text-[10px] uppercase tracking-[0.25em] text-[#5aa469] font-semibold">{data.tag}</p>
          {data.items.map(([n, p], i) => (
            <motion.div key={n} initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.15 + i * 0.1 }} className="flex justify-between items-center">
              <div className="flex items-center gap-3 min-w-0"><div className="h-11 w-11 rounded-xl bg-[#F4F7F4] shrink-0" /><span className="text-sm text-gray-800 truncate">{n}</span></div>
              <span className="text-sm font-semibold text-gray-900 whitespace-nowrap">{p} €</span>
            </motion.div>
          ))}
          <div className="pt-2 flex items-center justify-center gap-2 h-11 rounded-full bg-gray-900 text-white text-xs font-medium"><QrCode className="h-4 w-4 text-[#8fd39c]" /> QR · menuone.it</div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export const LivePhone = () => {
  const [slug, setSlug] = useState(undefined);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get("/public/showcase-menu").then((r) => setSlug(r.data.slug)).catch(() => setSlug(null));
  }, []);

  return (
    <div className="relative mx-auto w-[300px] sm:w-[330px]" data-testid="live-phone">
      <div className="absolute -inset-10 rounded-full bg-[#5aa469]/25 blur-3xl" />
      <div className="relative rounded-[2.6rem] bg-gray-900 p-2.5 shadow-2xl shadow-gray-900/30 ring-1 ring-white/10">
        <div className="absolute left-1/2 -translate-x-1/2 top-4 h-1.5 w-16 rounded-full bg-black/60 z-10" />
        <div className="rounded-[2.1rem] bg-white overflow-hidden h-[620px] sm:h-[660px] relative">
          {slug ? (
            <>
              {!ready && <div className="absolute inset-0 flex items-center justify-center bg-white"><Loader2 className="h-6 w-6 animate-spin text-[#5aa469]" /></div>}
              <iframe title="Menù MenuOne" src={`/menu/${slug}`} onLoad={() => setReady(true)} className="w-full h-full border-0" data-testid="live-phone-iframe" />
            </>
          ) : <MockScreen />}
        </div>
      </div>
      {slug && (
        <p className="mt-5 text-center text-xs text-gray-500" data-testid="live-phone-caption">
          Menù reale · piano <span className="font-semibold text-gray-900">Business</span> · provalo, è interattivo
        </p>
      )}
      <div className="absolute -left-28 top-44 hidden lg:flex items-center gap-2 rounded-full bg-white border border-gray-200 shadow-lg px-3 py-2 text-xs font-medium mo-float" style={{ animationDelay: "0.6s" }}>
        <span className="h-2 w-2 rounded-full bg-[#5aa469]" /> Sempre aggiornato
      </div>
      <div className="absolute -right-24 bottom-40 hidden lg:flex items-center gap-2 rounded-full bg-white border border-gray-200 shadow-lg px-3 py-2 text-xs font-medium mo-float" style={{ animationDelay: "1.4s" }}>
        <QrCode className="h-3.5 w-3.5 text-[#5aa469]" /> Unico QR Code
      </div>
    </div>
  );
};
